// extracted by mini-css-extract-plugin
export default {"background":"style_background__kxiY-","container":"style_container__XjLT6","circle":"style_circle__20E5j","checkIcon":"style_checkIcon__oGLos"};